/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { createAction } from "@reduxjs/toolkit";

import type {
  AuthOrchestrationStatus,
  IpAutoLoginStatus
} from "./signIn.types";

/**
 * Orchestration actions the sign-in thunks dispatch on their own progress.
 *
 * They are declared with `createAction` here rather than inside
 * `createSlice({ reducers })` so the flow modules can dispatch them without
 * importing the slice: the slice imports the thunks (to register their
 * lifecycle reducers), so a thunk importing the slice back would close an
 * import cycle and leave one side undefined at module-evaluation time.
 * The slice handles them in `extraReducers`; their type strings are the same
 * ones `createSlice` would have generated, so dispatching them is unchanged
 * for every caller.
 */
export const setAuthOrchestrationStatus = createAction<AuthOrchestrationStatus>(
  "signIn/setAuthOrchestrationStatus"
);

export const setIpAutoLoginStatus = createAction<IpAutoLoginStatus>(
  "signIn/setIpAutoLoginStatus"
);

export const markAuthTypeAttempted = createAction<string>(
  "signIn/markAuthTypeAttempted"
);

/** Signals that the runtime session is no longer recoverable. */
export const sessionInvalidated = createAction("signIn/sessionInvalidated");
